import { Typography, useTheme } from "@material-ui/core";
import useStyles from "../../containers/data/forms/forms-styles";

export const FlexBanner = (props: { text: string }) => {
	const { palette } = useTheme();
	const classes = useStyles();

	return (
		<Typography variant="body1" className={classes.disclaimer} style={{ backgroundColor: palette.inputTableDivider.main }}>
			{props.text}
		</Typography>
	);
};
